// eslint-disable-next-line import/prefer-default-export
export const POSSIBLE_DUPLICATES_ADD_PERSON_SET_IS_DRAWER_OPEN = 'POSSIBLE_DUPLICATES_ADD_PERSON_SET_IS_DRAWER_OPEN';
